import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContactForm from '../../components/ContactForm';
import CTAButton from '../../components/CTAButton';
import SEO from '../../components/SEO';

const VacuumCleaning = () => {
  return (
    <>
      <SEO 
        title="Vacuum Cleaning Services Kampala | Carpet, Sofa & Upholstery Cleaning"
        description="Professional vacuum cleaning for carpets, sofas & upholstery in Kampala. Deep extraction removes allergens, dirt & odors. Industrial-grade equipment. Call 0752 058 190"
        keywords="carpet cleaning Kampala, sofa cleaning Uganda, upholstery cleaning Kampala, vacuum cleaning services, furniture cleaning Uganda, allergen removal Kampala"
        url="https://blossomcleaningservices.com/services/vacuum-cleaning"
      />
      <Header />

      <Box sx={{ position: 'relative', py: 12, backgroundImage: 'url(https://images.unsplash.com/photo-1556911220-bff31c812dba?w=1920&q=80)', backgroundSize: 'cover', backgroundPosition: 'center', '&::before': { content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(34, 51, 95, 0.75)' } }}>
        <Container sx={{ position: 'relative', zIndex: 1 }}>
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <Typography variant="h1" sx={{ mb: 3, color: 'white', fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
              Vacuum Cleaning Services
            </Typography>
            <Typography variant="h5" sx={{ maxWidth: 800, color: 'rgba(255,255,255,0.95)', mb: 4 }}>
              Professional vacuum cleaning for sofas, chairs, and carpets
            </Typography>
            <CTAButton to="/contact">Book Vacuum Cleaning</CTAButton>
          </motion.div>
        </Container>
      </Box>

      <Box sx={{ py: 8 }}>
        <Container>
          <Typography variant="h3" sx={{ mb: 4, fontWeight: 600 }}>
            Deep Extraction Vacuum Cleaning
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            Regular vacuuming only removes surface dirt. Our professional vacuum cleaning service uses powerful extraction equipment to deep clean upholstery, carpets, and soft furnishings.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            We remove deep-seated dirt, dust mites, allergens, and odours from your sofas, chairs, mattresses, and carpets. Using specialised cleaning solutions and high-powered extraction, we restore freshness and extend the life of your furniture.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
            Perfect for homes with children, pets, or allergy sufferers. Our eco-friendly products are safe for all fabrics and leave no harmful residue.
          </Typography>
        </Container>
      </Box>

      <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
        <Container maxWidth="md">
          <ContactForm title="Schedule Vacuum Cleaning" showServiceSelect={false} />
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default VacuumCleaning;
